import { render, staticRenderFns } from "./messageApplyDialog.vue?vue&type=template&id=2634829f&lang=pug"
import script from "./messageApplyDialog.vue?vue&type=script&lang=js"
export * from "./messageApplyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports